import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Header from "./Header.jsx";
import { useNavigate } from "react-router-dom";
import exambpp from "../EXAMBPPP-logo.png";
import parseHtml from "html-react-parser";
import elips from "../Ellipse.png"
// import Webcam from "react-webcam";
import { API_URL, SECRET_SESSION, API_URL_LOGIN, API_URL_LOG, API_URL_PHOTO } from "../constants";
import { decrypt, decrypt_res, encrypt_res } from "./shares/GlobalFunction.jsx";
import ConfirmationModal from "./shares/ConfirmationModal.js";
import NoCopyText from "./shares/NoCopyText.js";
import Loader from "./shares/Loader.jsx";
import Camera from "./shares/Camera.js";
import axiosInstance from "./shares/axiosConfig.js";
import AlertModal from "./shares/AlertModal.js";
import Swal from "sweetalert2";
import ResetModal from "./shares/ResetModal.js";
// import speedTest from "speedtest-net";

const baseURL = API_URL + "/login/info";

function KonfirmasiData() {
  const [isLoading, setIsLoading] = useState(true);
  const [effectsCompleted, setEffectsCompleted] = useState(0);
  const [post, setPost] = React.useState(null);
  const [hasError, setHasError] = useState(false);
  const [hasError2, setHasError2] = useState(false);
  const [isResetModalOpen, setModalResetOpen] = useState(false);
  const [dataProjek, setDataProjek] = useState(null);
  const [titleResetModal, setResetTitle] = useState("");
  const [subResetModal, setResetSub] = useState("");
  const [titleAlertModal, setAlertTitle] = useState("");
  const [pp, setPP] = useState("");
  const [kamera, isKamera] = useState("");
  const [cameraAvailable, setCameraAvailable] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  const [isSolidCamera, setIsSolidCamera] = useState(false);
  const [firstCapture, setFirstCapture] = useState(null);
  // let sminat_jurusan = localStorage.getItem("minat_jurusan") || "";
  // let sminat_jurusan2 = localStorage.getItem("minat_jurusan2") || "";
  

  const navigate = useNavigate();
  const accessToken = localStorage.getItem("token");

  let userData = localStorage.getItem("user");
  if (userData) {
    userData = JSON.parse(decrypt(userData));
    // alert(JSON.stringify(userData));
    // alert(userData.minat_jurusan1);

    // setUrlBackground(`
    //   data:image/svg+xml;utf8,
    //   <svg xmlns='http://www.w3.org/2000/svg' width='200' height='50'>
    //     <text x='0' y='30' font-size='30' fill='gray'>${userData.nopes}</text>
    //   </svg>
    // `.replace(/\n/g, '').trim());
    
  } else {
    navigate("/login");
  }
  const [minat_jurusan, setMinatJurusan] = useState(userData.minat_jurusan1);
  const [minat_jurusan2, setMinatJurusan2] = useState(userData.minat_jurusan2);
  const effectRan = useState(false);
  const logCameraDevices = async () => {
    try {
      // 1. trigger permission
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach((t) => t.stop());
  
      // 2. enumerate devices
      const devices = await navigator.mediaDevices.enumerateDevices();
      const cameras = devices.filter((d) => d.kind === "videoinput");
  
      console.log("=== CAMERA DEVICES ===");
      cameras.forEach((cam, i) => {
        console.log({
          index: i,
          deviceId: cam.deviceId,
          label: cam.label,
          groupId: cam.groupId,
        });
      });
  
      console.log(`Total cameras: ${cameras.length}`); 
    } catch (err) {
      console.error("Camera error:", err);
    }
  };
  
  // const speedTest = require('speedtest-net');
  

  React.useEffect(() => {
    if (effectRan.current) return;
    effectRan.current = true;
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      url: window.location.href,
      kategori: "Mulai Tes",
      sub_kategori: "Konfirmasi Data", 
      type: 'log',
      keterangan: `${userData.nopes} berhasil masuk ke halaman konfirmasi data`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    axios.post(baseURL).then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    });
    axios.post(API_URL + "/peserta/info_projek", {
      id_projek: userData.id_projek
    }, {headers: {Authorization: `Bearer ${accessToken}`}})
    .then((response) => {
      setDataProjek(response.data.res);
      localStorage.setItem("kamera", response.data.res.kamera);
    })
    // setPP(userData.photo);
  }, []);

  useEffect(() => {
    initDevices();
    if (dataProjek && dataProjek.kamera != 0) {
      navigator.mediaDevices.getUserMedia({ video: true })
        .then((stream) => {
          setCameraAvailable(true); // Kamera berhasil nyala
          stream.getTracks().forEach(track => track.stop()); // Stop sementara
          // log kamera nyala
          const payload_log = {
            id_siswa: userData.id_siswa,
            nopes: userData.nopes,
            nama_siswa: userData.nama_siswa,
            id_projek: userData.id_projek,
            url: window.location.href,
            kategori: "Mulai Tes",
            sub_kategori: "Konfirmasi Data", 
            type: 'log',
            keterangan: `${userData.nopes} kamera berhasil menyala`,
            timeStamp: Math.floor(Date.now() / 1000)
          }
          const encryptedPayload_log = encrypt_res(
            JSON.stringify(payload_log),
            SECRET_SESSION
          );
          axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
            data: encryptedPayload_log
          })
        })
        .catch(() => {
          setCameraAvailable(false); // Kamera gagal nyala
          // log kamera gagal nyala
          const payload_log = {
            id_siswa: userData.id_siswa,
            nopes: userData.nopes,
            nama_siswa: userData.nama_siswa,
            id_projek: userData.id_projek,
            type: 'log',
            url: window.location.href,
            kategori: "Mulai Tes",
            sub_kategori: "Konfirmasi Data", 
            keterangan: `${userData.nopes} kamera gagal menyala`,
            timeStamp: Math.floor(Date.now() / 1000)
          }
          const encryptedPayload_log = encrypt_res(
            JSON.stringify(payload_log),
            SECRET_SESSION
          );
          axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
            data: encryptedPayload_log
          })
        });
    }
  }, [dataProjek]);


  useEffect(() => {
    if (effectsCompleted >= 1) {
      setIsLoading(false);
    }
  }, [effectsCompleted]);
  const toInputToken = () => {
    localStorage.setItem("minat_jurusan", minat_jurusan);
    localStorage.setItem("minat_jurusan2", minat_jurusan2);
    // axiosInstance.post(API_URL + "/peserta/minat_jurusan", {
    //   id_siswa: userData.id_siswa,
    //   minat_jurusan: minat_jurusan,
    //   minat_jurusan2: minat_jurusan2,
    //   nopes: userData.nopes,
    //   kode_akses: userData.kode_akses,
    // });

    navigate(`/peserta/confirmtoken?username=${userData.nopes}&event=${userData.id_projek}`);
  };
  function isSolidColor(base64Image, threshold = 0.95, tolerance = 15) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64Image;
  
      img.onload = () => {
        // Buat canvas
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
  
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
  
        const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const totalPixels = canvas.width * canvas.height;
  
        // Ambil warna pixel pertama sebagai kandidat warna dominan
        const r0 = data[0], g0 = data[1], b0 = data[2];
  
        let similarCount = 0;
  
        for (let i = 0; i < data.length; i += 4) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];
  
          const diff =
            Math.abs(r - r0) +
            Math.abs(g - g0) +
            Math.abs(b - b0);
  
          // Jika perbedaan warna kecil → dianggap sama
          if (diff < tolerance) {
            similarCount++;
          }
        }
  
        const ratio = similarCount / totalPixels;
        const payload_log = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Kamera Peserta",
          sub_kategori: "capture", 
          keterangan: `${userData.nopes} persentase solid color ${ratio}`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_log = encrypt_res(
          JSON.stringify(payload_log),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload_log
        })
        resolve(ratio >= threshold);
      };
    });
  }  
  function isStaticImage(currentBase64, previousBase64, threshold = 0.98, tolerance = 10) {
    return new Promise((resolve) => {
      const img1 = new Image();
      const img2 = new Image();
  
      img1.src = previousBase64;
      img2.src = currentBase64;
  
      let loaded = 0;
  
      const onLoad = () => {
        loaded++;
        if (loaded < 2) return;
  
        // Buat canvas
        const canvas1 = document.createElement("canvas");
        const canvas2 = document.createElement("canvas");
  
        canvas1.width = img1.width;
        canvas1.height = img1.height;
  
        canvas2.width = img2.width;
        canvas2.height = img2.height;
  
        const ctx1 = canvas1.getContext("2d");
        const ctx2 = canvas2.getContext("2d");
  
        ctx1.drawImage(img1, 0, 0);
        ctx2.drawImage(img2, 0, 0);
  
        const data1 = ctx1.getImageData(0, 0, canvas1.width, canvas1.height).data;
        const data2 = ctx2.getImageData(0, 0, canvas2.width, canvas2.height).data;
  
        let similarCount = 0;
        let checked = 0;
  
        // Sampel pixel, misal setiap 10 pixel untuk efisiensi
        const step = 10;
  
        for (let i = 0; i < data1.length; i += 4 * step) {
          const r1 = data1[i], g1 = data1[i + 1], b1 = data1[i + 2];
          const r2 = data2[i], g2 = data2[i + 1], b2 = data2[i + 2];
  
          const diff =
            Math.abs(r1 - r2) +
            Math.abs(g1 - g2) +
            Math.abs(b1 - b2);
  
          if (diff < tolerance) similarCount++;
          checked++;
        }
  
        const similarity = similarCount / checked;
  
        resolve(similarity >= threshold); // true → gambar statis
      };
  
      img1.onload = onLoad;
      img2.onload = onLoad;
    });
  }  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const webcamRef = useRef(null);
  const [cameras, setCameras] = useState([]);
  const [camIndex, setCamIndex] = useState(0);
  const [deviceId, setDeviceId] = useState(null);

  const initDevices = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    stream.getTracks().forEach(t => t.stop());
  
    const devices = await navigator.mediaDevices.enumerateDevices();
    const cams = devices.filter(d => d.kind === "videoinput");
  
    setCameras(cams);
  
    const startIndex = 0;
    setCamIndex(startIndex);
    setDeviceId(cams[startIndex]?.deviceId ?? null);
  
    console.log("Cameras:", cams.map((c, i) => ({ i, label: c.label, id: c.deviceId })));
  };

  const confirmNextCamera = () => {
    if (cameras.length === 0) return;
  
    const next = (camIndex + 1) % cameras.length;
    setCamIndex(next);
    setDeviceId(cameras[next].deviceId);
  
    console.log("Switch to:", next, cameras[next].label);
  };

  // const [capturedImage, setCapturedImage] = useState(null);

  // const capture = () => {
  //   if (webcamRef.current) {
  //     const imageSrc = webcamRef.current.getScreenshot({
  //       width: 640,
  //       height: 480,
  //     });
  //     // setCapturedImage(imageSrc);
  //   } else {
  //     console.error("Webcam reference is null");
  //   }
  // };
  const [isModalOpen, setModalOpen] = useState(false);
  const [isStopModalOpen, setModalStopOpen] = useState(false);
  const [catatanPengawas, setCatatan] = useState('');
  const handleOpenModal = () => {
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Mulai Tes",
      sub_kategori: "Konfirmasi Data", 
      keterangan: `${userData.nopes} klik tombol lanjutkan pada halaman konfirmasi data`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    if (post && parseInt(post.minat_jurusan) !== 0) {
      if (!minat_jurusan || minat_jurusan.trim().length === 0) {
        setHasError(true);
        return;
      }

      if (!minat_jurusan2 || minat_jurusan2.trim().length === 0) {
        setHasError2(true);
        return;
      }
    }
    // console.log((!cameraAvailable || isSolidCamera), !cameraAvailable, isSolidCamera);
    if (dataProjek && dataProjek.kamera === 1 && !cameraAvailable){
      setAlertTitle("Kamera Perangkat");
      setCatatan("Pastikan kamera pada perangkat anda menyala!");
      setModalStopOpen(true);
      const payload_log = {
        id_siswa: userData.id_siswa,
        nopes: userData.nopes,
        nama_siswa: userData.nama_siswa,
        id_projek: userData.id_projek,
        type: 'log',
        url: window.location.href,
        kategori: "Mulai Tes",
        sub_kategori: "Konfirmasi Data",
        remaining_time: 0,
        keterangan: `${userData.nopes} belum bisa attempt ujian karena kamera belum menyala`,
        timeStamp: Math.floor(Date.now() / 1000)
      }
      const encryptedPayload_log = encrypt_res(
        JSON.stringify(payload_log),
        SECRET_SESSION
      );
      axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
        data: encryptedPayload_log
      })
      return;
    }
    // if (isMobile) {
    //   setAlertTitle("Perangkat Peserta");
    //   setCatatan("Harap menggunakan komputer untuk tes ini");
    //   setModalStopOpen(true);
    //   return;
    // }
    // if (userData.pengawas == 1 || true){
    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      password: userData.kode_akses,
      id_ujian: 0,
      token: accessToken
    };
    
    // Encrypt payload following the app pattern
    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );
          
      // Make API call to check access status
    const start = Date.now();
    axiosInstance
    .post(API_URL + "/peserta/checkAccessStatus", {
      data: encryptedPayload,
    })
    .then((response) => {
      // Decrypt the response
      const end = Date.now();
      const ping = end - start;
      const decryptedResponse = response.data.res;
      
      // Set the access status
      // setAccessStatus(decryptedResponse);
      
      // Log the response to console
      // console.log("Access Status Check Response:", decryptedResponse);
      // Check for status - but not implementing the stopping logic yet
      if (decryptedResponse && decryptedResponse.length > 0) {
        const statusCheck = decryptedResponse[0];
        // console.log(`Access Status ID: ${statusCheck.id_akses_ujian}, Status: ${statusCheck.nama_akses_ujian}, Notes: ${statusCheck.text_catatan}`);
        
        if (userData.pengawas == 1){
          
          if(statusCheck.id_akses_ujian === 44 || statusCheck.id_akses_ujian === 57) {
            // Test is stopped - to be implemented later
            // navigate("/peserta/logout");
            if (!statusCheck['text_catatan'] || statusCheck['text_catatan'] == ''){
              setCatatan("Anda dihentikan oleh pengawas");
            }else {
              setCatatan(statusCheck['text_catatan']);
            }
            setAlertTitle("Catatan Penghentian Ujian");
            setModalStopOpen(true);
          }else if (statusCheck.id_akses_ujian === 21){
            setAlertTitle("Akses Ujian");
            setCatatan("Anda belum memiliki akses login. Silahkan hubungi pengwawas untuk mendapatkan akses.");
            setModalStopOpen(true);
          }
          else if (statusCheck.req_reset == 1 ){
            setResetTitle("Perlu Reset Login");
            setResetSub("Akun anda masih dalam status login, klik tombol di bawah untuk membuat permintaan reset login pada pengawas!")
            //matikan ini jika tidak perlu request reset login
            // setModalResetOpen(true);
          }else if (!statusCheck.time_login){
            setAlertTitle("Waktu Ujian");
            setCatatan("Anda belum memasuki waktu pelaksanaan ujian");
            setModalStopOpen(true);
          }else{
            if (cameraAvailable && dataProjek.kamera === 1){
              var captureImage = webcamRef.current.getScreenshot({
                width: 480,
                height: 320,
              });
              setFirstCapture(captureImage);
            }
            if (captureImage && dataProjek.kamera === 1){
              isSolidColor(captureImage, 0.95, 15).then((result) => {
                if (result){
                  setAlertTitle("Kamera Perangkat");
                  setCatatan("Pastikan kamera pada perangkat anda menyala!");
                  setModalStopOpen(true);
                  return;
                  // setIsSolidCamera(true)
                }else {
                  setModalOpen(true);
                }
              })
            }else{
              setModalOpen(true);
            }
            return;
          }
        }else {
          console.log(statusCheck.time_login);
          if (!statusCheck.time_login){
            setAlertTitle("Waktu Ujian");
            setCatatan("Anda belum memasuki waktu pelaksanaan ujian");
            setModalStopOpen(true);
          }else{
            setModalOpen(true);
          }
        }
        // Here you would eventually implement the stopping logic
        // if (statusCheck.id_akses_ujian === 21) {
        //   // Test is stopped - to be implemented later
        // }
      }

      // nanti uncomment yang ini kalau mau 
      // setModalOpen(true);
    })
    .catch((error) => {
      if (error.response?.data && error.response.data.res[0].id_akses_ujian != 20){
        setCatatan(error.response.data.res[0].text_catatan);
        setModalStopOpen(true);
      }
      if (error.code == 'ERR_NETWORK'){
        console.log("ini masalah jaringan");
      }
      console.error("Error checking access status:", error.code);
    });
  };
  const handleConfirmStop = () => {
    setModalStopOpen(false);
  }
  const handleConfirmReset = () => {
    setModalResetOpen(false);
    // Here you will implement post to request reset login
    let userData = localStorage.getItem("user");
    if (userData) {
      userData = JSON.parse(decrypt(userData));
    } else {
      navigate("/login");
    }
    const payload = {
      id_siswa: userData.id_siswa,
      id_pengawas: userData.id_pengawas,
      id_kelompok_ujian: userData.id_kelompok_ujian,
      nama_siswa: userData.nama_siswa,
      username: userData.nopes,
      password: userData.kode_akses
    };
    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Mulai Tes",
      sub_kategori: "Konfirmasi Data", 
      keterangan: `${userData.nopes} mengirimkan request reset login`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    axiosInstance.post(API_URL_LOGIN + "/peserta/req_resetlogin", {data: encryptedPayload})
    .then(response => {
      // Swal.fire({
      //   title: "Success!",
      //   text: "Request Reset Login Berhasil dikirim",
      //   icon: "success",
      //   confirmButtonText: "OK"
      // });
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      setModalResetOpen(false);
      navigate("/login", {
        state: {modalOpen: true}
      });
    })
    .catch(error => {
      Swal.fire({
        title: "Error",
        text: error,
        icon: "error",
        confirmButtonText: "OK"
      })
      setModalResetOpen(false);
    });
  }
  const handleConfirm = () => {
  //   let captureImage = webcamRef.current.getScreenshot({
  //     width: 480,
  //     height: 320,
  // });
  // if (captureImage){
  //   const payload_capture = {
  //     id_projek: userData.id_projek,
  //     id_siswa: userData.id_siswa,
  //     id_ujian: 0,
  //     nopes: userData.nopes,
  //     image: captureImage,
  //     timeStamp: Math.floor(Date.now() / 1000)
  //   }
  //   const encryptedPayload_capture = encrypt_res(
  //     JSON.stringify(payload_capture),
  //     SECRET_SESSION
  //   );
  //   axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
  //     data: encryptedPayload_capture
  //   });
  //   } else {
  //     const payload_log = {
  //       id_siswa: userData.id_siswa,
  //       nopes: userData.nopes,
  //       nama_siswa: userData.nama_siswa,
  //       id_projek: userData.id_projek,
  //       type: 'log',
  //       url: window.location.href,
  //       kategori: "Mulai Tes",
  //       sub_kategori: "Konfirmasi Data",
  //       remaining_time: 0,
  //       keterangan: `${userData.nopes} kamera tidak aktif`,
  //       timeStamp: Math.floor(Date.now() / 1000)
  //     }
  //     const encryptedPayload_log = encrypt_res(
  //       JSON.stringify(payload_log),
  //       SECRET_SESSION
  //     );
  //     axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
  //       data: encryptedPayload_log
  //     })
  //   }
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Mulai Tes",
      sub_kategori: "Konfirmasi Data", 
      keterangan: `${userData.nopes} klik ya, lanjutkan pada dialog konfirmasi data, "data sudah benar"`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    if (cameraAvailable && dataProjek.kamera === 1){
      let captureImage = webcamRef.current.getScreenshot({
        width: 480,
        height: 320,
      });
      if (captureImage){
        const payload_capture = {
          id_projek: userData.id_projek,
          id_siswa: userData.id_siswa,
          id_ujian: 0,
          nopes: userData.nopes,
          image: captureImage,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_capture = encrypt_res(
          JSON.stringify(payload_capture),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
          data: encryptedPayload_capture
        });
        if (dataProjek.kamera === 1){
          setModalOpen(false);
          toInputToken();
          // isStaticImage(captureImage, firstCapture).then((result) => {
            
          //   if (result){
          //     // setAlertTitle("Kamera Perangkat");
          //     // setCatatan("Pastikan kamera menampilkan wajah peserta");
          //     // setModalStopOpen(true);
          //     // setModalOpen(false);
          //     const payload_log = {
          //       id_siswa: userData.id_siswa,
          //       nopes: userData.nopes,
          //       nama_siswa: userData.nama_siswa,
          //       id_projek: userData.id_projek,
          //       type: 'log',
          //       url: window.location.href,
          //       kategori: "Kamera",
          //       sub_kategori: "Konfirmasi Data",
          //       remaining_time: 0,
          //       keterangan: `${userData.nopes} kamera teridentifikasi static`,
          //       timeStamp: Math.floor(Date.now() / 1000)
          //     }
          //     const encryptedPayload_log = encrypt_res(
          //       JSON.stringify(payload_log),
          //       SECRET_SESSION
          //     );
          //     axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          //       data: encryptedPayload_log
          //     })
          //     setModalOpen(false);
          //     toInputToken();
          //     return;
          //   }else{
          //     setModalOpen(false);
          //     toInputToken();
          //   }
          // })
        }
      } else {
        const payload_log = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Mulai Tes",
          sub_kategori: "Konfirmasi Data",
          remaining_time: 0,
          keterangan: `${userData.nopes} kamera tidak aktif`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_log = encrypt_res(
          JSON.stringify(payload_log),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload_log
        })
        setAlertTitle("Kamera Perangkat");
        setCatatan("Pastikan kamera pada perangkat anda menyala!");
        setModalStopOpen(true);
      }
    }else {
      setModalOpen(false);
      toInputToken();
    }
  };

  // setelah klik logout pada modal maka logout

  const handleCancel = () => {
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Mulai Tes",
      sub_kategori: "Konfirmasi Data", 
      keterangan: `${userData.nopes} klik batal sehingga dialog konfirmasi data tertutup`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    setModalOpen(false);
  };
  if (isLoading) {
    let temp = `/peserta/confirmdata?username=${userData.username}&event=${userData.id_projek}`
    return <Loader destination={temp}/>;
  }

  return (
    <div className="App">
      <NoCopyText>
        <ConfirmationModal
          isOpen={isModalOpen}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          title={"Konfirmasi Data"}
          subtitle={
            "Apakah data Anda sudah benar ? Silahkan klik 'Ya, Lanjutkan' jika data sudah benar."
          }
        />
        <ResetModal
          isOpen={isResetModalOpen}
          onConfirm={handleConfirmReset}
          title={titleResetModal}
          subtitle={subResetModal}
          btn_text="Request Reset Login"
            
        />
        <AlertModal
          isOpen={isStopModalOpen}
          onConfirm={handleConfirmStop}
          title={titleAlertModal}
          subtitle={catatanPengawas}
          btn_text="Tutup"
        />
        <div className="App-header"
        style={{backgroundColor: "white"}}
        >
          <Header app_name={post && post.alamat} />
          <div
            className="flex flex-col-reverse sm:flex-row w-full p-0 sm:p-5 px-10 overflow-y-hidden relative"
            style={{
              marginTop: "70px",
            }}
          >
            <div
              className="login-container basis-1/4 sm:basis-2/3 block sm:block z-10 p-0 sm:p-5 px-0 sm:px-10 overflow-y-hidden relative"
              style={{
                minHeight: "200px",
                animation: "fadeInFromBottom 1s forwards"
              }}
            >
              {/* <div className="w-full border-b-2 border-gray-200 text-3xl pb-2">
                Konfirmasi Data
              </div> */}
              {!isMobile ? (
                <div>
                  <img
                    src={exambpp}
                    className="h-16 sm:h-24 md:h-24 lg:h-32 xl:h-32"  
                  ></img>
                  <div
                    className="relative mt-10 text-4xl sm:text-7xl"
                    style={{
                      fontFamily: '"Poppins", sans-serif',
                      fontWeight: 400,
                    }}
                  >
                    <img src={elips} className="absolute -top-6 left-0 object-cover z-0"></img>
                    <p className="z-10">Selamat Datang</p>
                  </div>
                </div>
              ): (
                <div
                  className="relative mt-10 text-4xl sm:text-7xl hidden sm:block"
                  style={{
                    fontFamily: '"Poppins", sans-serif',
                    fontWeight: 600,
                  }}
                >
                  <p className="z-10">Selamat Datang</p>
                </div>
              )}
              <div className="mt-5 sm:mt-5 text-justify">
                {dataProjek && dataProjek.info_selesai?.length > 0
                ? parseHtml(dataProjek.info_selesai)
                : parseHtml(post.informasi)}
              </div>
              <div
                className="mt-10 text-2xl sm:text-4xl"
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontWeight: 900,
                }}
              >
                <p>Selamat Mengerjakan !</p>
              </div>
              {isMobile ? (
                <div className="text-left pt-5">
                  <button
                    onClick={handleOpenModal}
                    type="button"
                    className="bg-[#4F8382] text-white py-2 w-4/5 rounded-xl"
                  >
                    Lanjutkan
                  </button>
                </div>
              ): null}
            </div>
            <div
              className="basis-full sm:basis-1/3 mt-20"
              style={{
                minHeight: "200px",
              }}
            >
              <div class="h-full bg-black w-[1px] hidden sm:block absolute left"></div>
              <div className="ml-0 sm:ml-10">
              {isMobile ? (
                <div className="flex flex-row">
                  <div className="flex flex-col justify-between relative">
                    <img
                      src={exambpp}
                      alt="Exam Logo"
                      className="h-16 sm:h-16 md:h-24 lg:h-32 xl:h-32"
                    />
                      <img src={elips} className="absolute top-16 left-0 object-cover z-0"></img>
                      <p className="z-10" style={{
                        fontSize: "20px",
                        fontFamily: '"Poppins", sans-serif',
                        fontWeight: 600,
                      }}>Selamat Datang</p>
                  </div>
                  <div className="flex-1 flex justify-end">
                    <Camera webcamRef={webcamRef} header={false} width="80%" deviceId={deviceId} />
                  </div>
                </div>
              ) : post && dataProjek && parseInt(post.camera) !== 0 && parseInt(dataProjek.kamera) !== 0 && cameraAvailable ? (
                <div className="w-full border-gray-200 pb-2 flex justify-start">
                  <Camera webcamRef={webcamRef} header={false} deviceId={deviceId}/>
                </div>
              ) : (
                <div className="w-full border-gray-200 pb-2 flex justify-start">
                  <img
                    src='https://storage.googleapis.com/storage-abm.bppp.kemdikbud.go.id/CameraDeliveryFix.svg'
                    alt="Profile"
                    className="border-gray rounded-xl border-1"
                    style={{ width: "50%", height: "50%" }}
                  />
                </div>
              )}
              {isMobile ? (
                <div 
                  className="login-container w-full h-[100%]  Bg-tutwuri contentLogin z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-5"
                  style={{
                    minHeight: "200px",
                    // maxHeight: "600px"
                  }}
                >
                  <div className="pt-2">
                    <div className=" text-sm">ID Peserta</div>
                    <div className="font-bold">{userData && userData.nopes}</div>
                  </div>
                  <div className="pt-2">
                    <div className=" text-sm">Nama Peserta</div>
                    <div className="font-bold">
                      {userData && userData.nama_siswa}
                    </div>
                  </div>
                  {userData?.kode_paket_soal && (
                    <div className="pt-2">
                      <div className="text-sm">Bidang Studi</div>
                      <div className="font-bold">{userData.kode_paket_soal}</div>
                    </div>
                  )}
                  <div className="pt-2">
                    <div className=" text-sm">Asal Instansi/Sekolah</div>
                    <div className="font-bold">{userData && userData.email}</div>
                  </div>
                  <div className="pt-2">
                    <div className=" text-sm">Nama Ruang</div>
                    <div className="font-bold">
                      {userData && userData.grup_peserta}
                    </div>
                  </div>

                  <div className="pt-2">
                    <div className=" text-sm">Sesi</div>
                    <div className="font-bold">{userData && userData.nisn}</div>
                  </div>
                </div>
              ): (
                <div>
                  <div className="w-full border-gray-200 text-xl pb-2" style={{fontWeight: 700}}>
                    Konfirmasi Data
                  </div>
                  <div className="pt-2">
                    <div className=" text-sm">ID Peserta</div>
                    <div className="font-bold">{userData && userData.nopes}</div>
                  </div>
                  <div className="pt-2">
                    <div className=" text-sm">Nama Peserta</div>
                    <div className="font-bold">
                      {userData && userData.nama_siswa}
                    </div>
                  </div>
                  {userData?.kode_paket_soal && (
                    <div className="pt-2">
                      <div className="text-sm">Bidang Studi</div>
                      <div className="font-bold">{userData.kode_paket_soal}</div>
                    </div>
                  )}
                  <div className="pt-2">
                    <div className=" text-sm">Asal Instansi/Sekolah</div>
                    <div className="font-bold">{userData && userData.email}</div>
                  </div>
                  <div className="pt-2">
                    <div className=" text-sm">Nama Ruang</div>
                    <div className="font-bold">
                      {userData && userData.grup_peserta}
                    </div>
                  </div>

                  <div className="pt-2">
                    <div className=" text-sm">Sesi</div>
                    <div className="font-bold">{userData && userData.nisn}</div>
                  </div>
                  <div className="text-left pt-5">
                    <button
                      onClick={handleOpenModal}
                      type="button"
                      className="bg-[#4F8382] text-white py-2 w-4/5 rounded-xl"
                    >
                      Lanjutkan
                    </button>
                  </div>
                </div>
              )}
              {post && parseInt(post.minat_jurusan) !== 0 && (
              <div className="pt-4 rounded-md mt-2">
                <div className=" text-left text-sm">
                  Jurusan yang diminati di Perguruan Tinggi
                </div>
                <div className="text-left w-full ">
                  <input
                    className="text-left  w-full bg-white  border border-gray-200 mt-4 mb-2 p-2 rounded-md"
                    type="text"
                    placeholder="Pilihan 1"
                    aria-label=""
                    name="minat_jurusan"
                    id="minat_jurusan"
                    value={minat_jurusan}
                    onChange={(e) => {
                      setMinatJurusan(e.target.value);
                      if (e.target.value.length > 0) {
                        setHasError(false);
                      } else {
                        setHasError(true);
                      }
                    }}
                    autoComplete="off"
                  />
                  {hasError && (
                    <div className="text-sm text-red-600">
                      Silahkan isi jurusan yang diminati
                    </div>
                  )}
                </div>

                <div className="text-left w-full ">
                  <input
                    className="text-left  w-full bg-white border border-gray-200 mt-1 mb-2 p-2 rounded-md"
                    type="text"
                    placeholder="Pilihan 2"
                    aria-label=""
                    name="minat_jurusan2"
                    id="minat_jurusan2"
                    value={minat_jurusan2}
                    onChange={(e) => {
                      setMinatJurusan2(e.target.value);
                      if (e.target.value.length > 0) {
                        setHasError2(false);
                      } else {
                        setHasError2(true);
                      }
                    }}
                    autoComplete="off"
                  />
                  {hasError2 && (
                    <div className="text-sm text-red-600">
                      Silahkan isi jurusan yang diminati
                    </div>
                  )}
                </div>
              </div> )}
              </div>
            </div>
          </div>
        </div>
      </NoCopyText>
    </div>
  );
}

export default KonfirmasiData;
